import type { PropsWithChildren } from 'react';

import type { NextRouter } from 'next/router';

import { ThemeProvider } from 'styled-components';

// @ts-ignore - zrs-cms does not yet export types
import { B2BLayout, ThemeCmsConstellation } from '@zillow/zrs-cms';

import { LAYOUT_MENU_ITEM_IDS, LAYOUT_MENU_ITEMS } from '../constants/layout';
import RentalsLogo from '../images/rentals-logo.svg';

interface Props {
  router: Partial<NextRouter>;
  env?: string;
}

const img =
  typeof RentalsLogo === 'string'
    ? { src: RentalsLogo, width: 215, height: 25, blurHeight: 0, blurWidth: 0 }
    : RentalsLogo;

export const RentalsB2BLayout = ({ children, router, env = 'production' }: PropsWithChildren<Props>): JSX.Element => {
  return (
    <ThemeProvider theme={ThemeCmsConstellation}>
      <B2BLayout
        router={router}
        env={env}
        signInLink="/rental-manager/login/"
        signInRedirectParam="url"
        menu={LAYOUT_MENU_ITEMS}
        primaryCTALabel="Post your listing"
        primaryCTALink="/rental-manager/properties?postingPath=true"
        secondaryCTALabel="Contact sales"
        secondaryCTALink="/rentals-network/contact-sales/"
        logo={{
          ...img,
          alt: 'Zillow Rentals Logo',
          link: '/rental-manager/',
        }}
        footerColumns={[
          {
            title: 'Rental manager',
            links: LAYOUT_MENU_ITEMS.filter((item) => item.parent === LAYOUT_MENU_ITEM_IDS.RentalManager).map(
              convertMenuItemToFooterLink,
            ),
          },
          {
            title: 'Apartment advertising',
            links: LAYOUT_MENU_ITEMS.filter((item) => item.parent === LAYOUT_MENU_ITEM_IDS.ApartmentAdvertising).map(
              convertMenuItemToFooterLink,
            ),
          },
        ]}
      >
        {children}
      </B2BLayout>
    </ThemeProvider>
  );
};

function convertMenuItemToFooterLink(item: (typeof LAYOUT_MENU_ITEMS)[number]) {
  return {
    title: item.title.rendered,
    url: item.url,
  };
}
